import { useEffect, useState } from "react";
import "./CheckoutComponent.css"; // Import CSS for styling
import {
  createOrderAPI,
  reInitiatePaymentAPI,
} from "../../../../Store/Action/orderAction";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../../Config/Images";
import { clearCart } from "../../../../Store/Slice/cartSlice";
import { setCartItemCount } from "../../../../Store/Slice/popupTriggerSlice";
import {
  getCartAPI,
  getCartTotalAPI,
} from "../../../../Store/Action/cartAction";
import { useNavigate } from "react-router-dom";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import { toast } from "react-toastify";
import { paymentVerificationAPI } from "../../../../Store/Action/paymentAction";
import { resetWalletFlag } from "../../../../Store/Slice/walletSlice";

const CheckoutComponent = ({
  shippingAddress,
  isSameAddress,
  billingAddress,
  onClose,
  totalAmountData,
  closeThePopUp,
  retryPayment = false,
  totalAmount,
  orderId,
  manufacturer_id,
}) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  const liveRates = useSelector((state) => state.liveRate.rates);

  // const handleModalClose = () => {
  //   navigate("/my-account/my-orders");
  //   closeThePopUp();
  // };

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setUserData(result?.data);
      }),
    );
  }, [dispatch]);

  const handleProcessCheckOut = () => {
    const goldRate =
      liveRates.find((k) => k.metal?.toLowerCase() === "gold")?.rate || 0;

    const silverRate =
      liveRates.find((k) => k.metal?.toLowerCase() === "silver")?.rate || 0;

    const reqData = {
      shipping_address_id: shippingAddress?.[0]?.user_address_id,
      billing_address_id: isSameAddress
        ? shippingAddress?.[0]?.user_address_id
        : billingAddress?.user_address_id,
      live_rates: {
        gold: goldRate,
        silver: silverRate,
      },
      manufacturer_id: manufacturer_id,
    };

    dispatch(
      createOrderAPI(reqData, (result) => {
        if (result?.data?.status) {
          const order = result?.data?.data; // Razorpay order details from API

          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            // key: "rzp_test_5IIrDDi16Z7FLT",
            // key: "rzp_live_Yjucgea2ajzdsU",
            amount: order.amount, // ✅ In paise
            currency: order.currency,
            name: "Zabali Jewelex",
            description: "Order Payment",
            image: Icons.zabali_header_logo_icon,
            order_id: order.id, // ✅ This is the Razorpay order ID
            prefill: {
              name: userData?.[0]?.user_first_name,
              email: userData?.[0]?.user_email,
              contact: userData?.[0]?.user_mobile_number,
            },
            notes: order.notes,
            theme: {
              color: "#F37254",
            },
            handler: function (response) {
              // ✅ Payment success handler
              toast.success("Payment Successful!");
              dispatch(resetWalletFlag());
              navigate("/my-account/my-orders");
              dispatch(clearCart());
              dispatch(
                getCartAPI({}, (result) => {
                  const cartLength = result?.total_count;
                  dispatch(setCartItemCount(cartLength));
                }),
              );
              // Here you can optionally call a `verify-payment` API

              // const verifyData = {
              //   razorpay_payment_id: response.razorpay_payment_id,
              //   razorpay_order_id: response.razorpay_order_id,
              //   razorpay_signature: response.razorpay_signature,
              // };

              // dispatch(
              //   paymentVerificationAPI(verifyData, (verifyResult) => {
              //     if (verifyResult?.data?.status === "success") {
              //       toast.success("Payment Verified Successfully!");
              //       // navigate("/order-confirmation");
              //     } else {
              //       toast.error("Payment verification failed.");
              //     }
              //   })
              // );
            },
            modal: {
              // ✅ Razorpay popup dismissed handler
              ondismiss: function () {
                toast.error("Payment Cancelled!");
                navigate("/my-account/my-orders");
                // Optionally: clean up state or navigate
              },
            },
          };

          const rzp = new window.Razorpay(options);

          // ❌ Add payment failure handler here
          rzp.on("payment.failed", function (response) {
            toast.error("Payment Failed!");
            console.log("Payment Failed: ", response.error);
            // Optional: Redirect or show modal
            // navigate("/payment-failed");
          });

          rzp.open(); // ✅ Open Razorpay Checkout popup

          const url = result?.data?.data;
          // if (url) {
          //   window.open(url, "_blank");
          // } else {
          //   console.log("something went wrong!");
          // }
        } else {
          // console.log("something went wrong!");
          // toast.error(result?.data?.error);
          toast.error("something went wrong!");
        }
      }),
    );
    closeThePopUp();
  };

  const handleRetryProcessCheckOut = (orderId) => {
    const reqData = {
      order_id: orderId,
      // order_id: orderData?.order_id,
      // user_id: orderData?.user_id,
      // rtgs_number: rtgsNumber,
      // bank_account_id: selectedBankId,
      // transaction_amount: Number(amount),
      // transaction_file_storage_id: rtgsFileId,
    };
    dispatch(
      reInitiatePaymentAPI(reqData, (result) => {
        if (result?.status) {
          const order = result?.data; // Razorpay order details from API
          const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            // key: "rzp_test_5IIrDDi16Z7FLT",
            // key: "rzp_live_Yjucgea2ajzdsU",
            amount: order.amount, // ✅ In paise
            currency: order.currency,
            name: "Zabali Jewelex",
            description: "Order Payment",
            image: Icons.zabali_header_logo_icon,
            order_id: order.id, // ✅ This is the Razorpay order ID
            prefill: {
              name: userData?.[0]?.user_first_name,
              email: userData?.[0]?.user_email,
              contact: userData?.[0]?.user_mobile_number,
            },
            notes: order.notes,
            theme: {
              color: "#F37254",
            },
            handler: function (response) {
              // ✅ Payment success handler
              toast.success("Payment Successful!");
              navigate("/my-account/my-orders");
              // dispatch(clearCart());
              // dispatch(
              //   getCartAPI({}, (result) => {
              //     const cartLength = result?.total_count;
              //     dispatch(setCartItemCount(cartLength));
              //   })
              // );
            },
          };

          const rzp = new window.Razorpay(options);

          // ❌ Add payment failure handler here
          rzp.on("payment.failed", function (response) {
            toast.error("Payment Failed!");

            // Optional: Redirect or show modal
            // navigate("/payment-failed");
          });

          rzp.open(); // ✅ Open Razorpay Checkout popup
        } else {
          toast.error("Something went wrong!");
        }
      }),
    );
    closeThePopUp();
  };

  // useEffect(() => {
  //   if (!goldRate || !silverRate) return;
  //   const params = {
  //     gold_rate: goldRate,
  //     silver_rate: silverRate,
  //   };
  //   dispatch(
  //     getCartTotalAPI(params, (result) => {
  //       setAdvancePayableValue(result?.data?.[0]?.advance_payment_value);
  //     })
  //   );
  // }, [goldRate, silverRate]);
  return (
    <div className="modal-overlay-checkout">
      <div
        className="modal-container-checkout"
        style={{ position: "relative" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "14px",
          }}
        >
          {/* <img style={{height:"80px"}} src={Icons.zabali_header_logo_icon} alt="" /> */}
        </div>
        <div className="cross-close-icon">
          <img onClick={onClose} src={Icons.cross_icon} alt="" />
        </div>
        {/* <h2 className="modal-title-checkout">Order Confirmation Received</h2> */}
        <h2 className="modal-title-checkout">
          Payment & Order Confirmation Policy
        </h2>
        <div className="modal-list-checkout">
          {/* <p>Our team will contact you within 24 hours to assist further.</p> */}
          {/* <p>Thank you for showing interest in us.</p> */}
          <li>
            You are required to pay an advance amount of{" "}
            <b style={{ color: "#9c7726" }}>₹{totalAmountData}</b> at the time
            of placing your order.
          </li>
          <li>
            The final price will be determined based on the total weight of the
            finished product after production.
          </li>
          <li>
            Once your order is completed, we will notify you of the total weight
            and final payable amount.
          </li>
          <li>
            The advance payment will be adjusted against the final amount.
          </li>
          <li>
            You must complete the remaining payment before we ship your order.
          </li>
        </div>

        {/* Terms Checkbox */}
        <div className="modal-checkbox-checkout">
          <label htmlFor="agreeTerms">
            {/* <input
              onChange={() => setIsChecked(!isChecked)}
              type="checkbox"
              id="agreeTerms"
              checked={isChecked}
            /> */}
            <input
              type="checkbox"
              id="agreeTerms"
              checked={isChecked}
              onChange={() => setIsChecked(!isChecked)}
              style={{
                border: "1px solid #DFDFDF",
                cursor: "pointer",
                width: "16px",
                height: "16px",
                accentColor: "#9c7726", // Change the checkmark color
              }}
            />{" "}
            <span
              className="checkbox-text-checkout"
              style={{ cursor: "pointer" }}
            >
              {" "}
              By proceeding with this payment, you agree to our terms and
              conditions.
            </span>
          </label>
        </div>

        {/* Buttons */}
        <div className="modal-buttons-checkout">
          <button
            className="proceed-btn-checkout"
            // onClick={handleProcessCheckOut}
            onClick={
              retryPayment
                ? () => handleRetryProcessCheckOut(orderId)
                : handleProcessCheckOut
            }
            // onClick={handleModalClose}
            disabled={!isChecked}
          >
            Process to Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutComponent;
